// src/Impressum.js — AVS Cloud | §5 DDG | Stand: Juni 2026
import React, { useEffect } from 'react';
import { setPageMeta } from './utils/seo';

const styles = {
  wrap: {
    minHeight: '100vh',
    padding: '2rem clamp(1rem, 4vw, 2.5rem) 5rem',
    position: 'relative',
    zIndex: 1,
  },
  inner: { maxWidth: '760px', margin: '0 auto' },
  back: {
    display: 'inline-flex', alignItems: 'center', gap: '6px',
    fontSize: '0.8rem', fontWeight: 600, color: 'var(--muted)',
    letterSpacing: '0.04em', textDecoration: 'none', marginBottom: '2.5rem',
    cursor: 'pointer', transition: 'color 0.2s',
  },
  title: {
    fontFamily: 'var(--font-head)', fontSize: 'clamp(2rem, 5vw, 3rem)',
    fontWeight: 900, letterSpacing: '-0.04em', color: 'var(--white)',
    marginBottom: '0.4rem', lineHeight: 1.1,
  },
  subtitle: {
    fontSize: '0.82rem', color: 'var(--muted)', marginBottom: '2.5rem',
    letterSpacing: '0.04em', paddingBottom: '2rem', borderBottom: '1px solid var(--border)',
  },
  block: { padding: '1.75rem 0', borderBottom: '1px solid var(--border)' },
  blockLast: { padding: '1.75rem 0' },
  heading: {
    fontSize: '0.95rem', fontWeight: 700, color: 'var(--cyan)',
    letterSpacing: '-0.01em', marginBottom: '0.85rem', fontFamily: 'var(--font-head)',
  },
  p: { fontSize: '0.88rem', color: 'var(--muted)', lineHeight: 1.8, margin: 0 },
  pmt: { fontSize: '0.88rem', color: 'var(--muted)', lineHeight: 1.8, marginTop: '0.75rem' },
  link: { color: 'var(--cyan)', textDecoration: 'underline', textUnderlineOffset: '3px' },
};

export default function Impressum() {
  useEffect(() => {
    setPageMeta({
      title: 'Impressum | AVS Cloud – AquaV Services',
      description: 'Impressum von AVS Cloud. Angaben gemäß §5 DDG. Betreiber: Mert Munz, AquaV Services, c/o IP-Management #10553, Ludwig-Erhard-Str. 18, 20459 Hamburg.',
      path: '/impressum',
    });
  }, []);
  return (
    <div style={styles.wrap}>
      <div style={styles.inner}>
        <a href="/" style={styles.back}>← Zurück zur Cloud</a>
        <h1 style={styles.title}>Impressum</h1>
        <p style={styles.subtitle}>Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)</p>

        <div style={styles.block}>
          <h2 style={styles.heading}>Verantwortlicher</h2>
          <p style={styles.p}>Mert Munz</p>
          <p style={styles.p}>c/o IP-Management #10553</p>
          <p style={styles.p}>Ludwig-Erhard-Str. 18</p>
          <p style={styles.p}>20459 Hamburg</p>
          <p style={styles.p}>Deutschland</p>
        </div>

        <div style={styles.block}>
          <h2 style={styles.heading}>Unternehmensform</h2>
          <p style={styles.p}>Gewerbetreibender (Einzelunternehmen)</p>
          <p style={styles.pmt}>Gewerbeanmeldung beim Gewerbeamt der Stadt Rastatt</p>
          <p style={styles.pmt}>Tätigkeitsbeginn: 20.03.2026</p>
        </div>

        <div style={styles.block}>
          <h2 style={styles.heading}>Kontakt</h2>
          <p style={styles.p}>
            E-Mail:{' '}
            <a href="mailto:aquavservices@gmail.com" style={styles.link}>
              aquavservices@gmail.com
            </a>
          </p>
          <p style={styles.pmt}>
            Discord (zweite unmittelbare Kontaktmöglichkeit):{' '}
            <a href="https://discord.gg/Wq5CbduU9P" target="_blank" rel="noopener noreferrer" style={styles.link}>
              discord.gg/Wq5CbduU9P
            </a>
          </p>
        </div>

        <div style={styles.block}>
          <h2 style={styles.heading}>Umsatzsteuer (§ 19 UStG)</h2>
          <p style={styles.p}>
            Mert Munz ist Kleinunternehmer gemäß § 19 Abs. 1 UStG
            (Kleinunternehmerregelung). Auf Rechnungen wird keine Umsatzsteuer
            ausgewiesen.
          </p>
        </div>

        <div style={styles.block}>
          <h2 style={styles.heading}>Meldung rechtswidriger Inhalte</h2>
          <p style={styles.p}>
            Rechtswidrige Inhalte, die über AVS Cloud geteilt werden, können
            gemeldet werden an:{' '}
            <a href="mailto:aquavservices@gmail.com?subject=Abuse" style={styles.link}>
              aquavservices@gmail.com
            </a>{' '}
            (Betreff: Abuse) oder über den Melde-Button auf der Share-Seite.
          </p>
          <p style={styles.pmt}>
            Meldungen werden unverzüglich geprüft. Klare rechtswidrige Inhalte
            werden sofort entfernt, komplexere Fälle innerhalb von 7 Tagen.
          </p>
        </div>

        <div style={styles.block}>
          <h2 style={styles.heading}>Streitschlichtung (§§ 36, 37 VSBG)</h2>
          <p style={styles.p}>
            Die Europäische Kommission stellt eine Plattform zur
            Online-Streitbeilegung (OS) bereit:{' '}
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" style={styles.link}>
              https://ec.europa.eu/consumers/odr/
            </a>
          </p>
          <p style={styles.pmt}>
            Wir sind nicht bereit und nicht verpflichtet, an einem
            Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
            teilzunehmen (§ 37 Abs. 1 VSBG).
          </p>
        </div>

        <div style={styles.block}>
          <h2 style={styles.heading}>Haftung für Inhalte</h2>
          <p style={styles.p}>
            Als Dienstanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte
            nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG
            sind wir nicht verpflichtet, übermittelte oder gespeicherte fremde
            Informationen zu überwachen. Bei Bekanntwerden von
            Rechtsverletzungen werden entsprechende Inhalte umgehend entfernt.
          </p>
        </div>

        <div style={styles.blockLast}>
          <h2 style={styles.heading}>Urheberrecht</h2>
          <p style={styles.p}>
            Die durch den Seitenbetreiber erstellten Inhalte und Werke auf
            diesen Seiten unterliegen dem deutschen Urheberrecht. Downloads und
            Kopien sind nur für den privaten, nicht kommerziellen Gebrauch
            gestattet. Soweit Inhalte auf dieser Seite nicht vom Betreiber
            erstellt wurden, werden die Urheberrechte Dritter beachtet.
          </p>
        </div>
      </div>
    </div>
  );
}
